export default "mutation disdettaLatitudine($params: DisdettaLatitudineParams!) {\n        disdettaLatitudine(params: $params)\n}";